export default __webpack_public_path__ + "static/screen_1_01-816e0f77254614b73b2a63f3b36e44c3.svg";